import { Router } from "@gatsbyjs/reach-router";
import React, { useState } from "react";
import { SystemContext } from "./context";
import UploadAndCleanData from "./upload/UploadAndCleanData";
import DataVisualizationTabs from './visualize/DataVisualizationTabs';
import DataVisualizationTabs_new from './visualize/DataVisualizationTabs_new';

import {
    AppBar,
    Avatar,
    Box,
    CssBaseline,
    IconButton,
    Toolbar,
    Tooltip,
    Typography,
} from "@material-ui/core";
import appConfig from "./config";
// import { logout } from "@carrier/reactauthwrapper";
import { logout } from '@carrier-sce-sharedpackages/auth-module';

import { Logout } from "@mui/icons-material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import useStyles from "./Style";
import getUsernameFromToken from "./User";
import logo from "./assets/logo.png";
// import UploadAndCleanData from './UploadAndCleanData';
// import DataVisualization from './DataVisualization';
// import NavigationDrawer from './NavigationDrawer'
// import MiniDrawer from "./MinDrawer";

// import { SystemContext } from './context';
import HelpIcon from '@mui/icons-material/Help';
import MenuIcon from "@mui/icons-material/Menu"; // Importing Menu Icon
import VerticalTabs from "./VerticalTabs"; // Importing VerticalTabs component

const settings = ["Logout"];
const icons = [<ExitToAppIcon />];

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
            style={{ flexGrow: 1, display: value === index ? 'block' : 'none' }}
        >
            {value === index && (
                <Box sx={{ p: 3, height: '100%', overflow: 'auto' }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}



const AutoMLWorkflow = ({ fetchAPI }) => {
    const [numberOfRows, setNumberOfRows] = useState('');
    const [numberOfColumns, setNumberOfColumns] = useState('');
    const [numberOfDuplicateRows, setNumberOfDuplicateRows] = useState('');
    const [numberOfDuplicateColumns, setNumberOfDuplicateColumns] = useState('');
    const [noOfRowsAfterCleaning, setNoOfRowsAfterCleaning] = useState('');
    const [noOfColsAfterCleaning, setNoOfColsAfterCleaning] = useState('');
    const [activeStep, setActiveStep] = React.useState(0);
    const [completed, setCompleted] = React.useState({});
    const [statsData, setStatsData] = useState({});
    const [balancedCols, setBalancedCols] = useState([]);


    const [numericalModeValue, setNumericalModeValue] = useState("Mean");
    const [categoricalModeValue, setCategoricalModeValue] = useState("Mode");
    const [outliersValue, setOutliersValue] = useState("");
    const [fileObjects, setfileObjects] = useState([]);
    const [outlinerMethod, setOutlinerMethod] = useState('None');
    const [fileName, setFileName] = useState('');
    const [actualFileName, setActualFileName] = useState('');
    const [cleanedData, setCleanedData] = useState([]);
    const [allColumns, setAllColumns] = useState([]);
    const [numericalColumns, setNumericalColumns] = useState([]);
    const [stringColumns, setStringColumns] = useState([]);

    const [rawOrCleanData, setRawOrCleanData] = useState('raw');
    const [missingData, setMissingData] = useState([]);
    const [tempCleanData, setTempCleanData] = useState([]);

    const [taskToDo, setTaskToDo] = useState([]);

    const [numericalStatsCol, setNumericalStatsCol] = useState([]);
    const [numericalStatsData, setNumericalStatsData] = useState({});

    const [categoricalStatsCol, setCategoricalStatsCol] = useState([]);
    const [categoricalStatsData, setCategoricalStatsData] = useState({});

    const [taskToDoValue, setTaskToDoValue] = useState('');
    const [targetVariableValue, setTargetVariableValue] = useState('');
    const [scalingTechniqueValue, setScalingTechniqueValue] = useState('');
    const [featureValue, setFeatureValue] = useState([]);
    const [strategForFeatureSelectionValue, setStrategForFeatureSelectionValue] = useState('');


    const [images, setImages] = useState([]);
    const [table1Data, setTable1Data] = useState([]);
    const [table2Data, setTable2Data] = useState([]);
    const [table3Data, setTable3Data] = useState([]);
    const [modelName, setModelName] = useState("");



    const [numberOfModelsToTrain, setNumberOfModelsToTrain] = useState([]);
    const [keyMetricValue, setKeyMetricValue] = useState("");

    const [timeStampCols, setTimeStampCols] = useState([]);
    const [numericalCleanedCols, setNumericalCleanedCols] = useState([]);
    const [categoricalCleanedCols, setCategoricalCleanedCols] = useState([]);
    const [allCleanedCols, setAllCleanedCols] = useState([]);
    const [cleaningInfo, setCleaningInfo] = useState({})
    const [dupCols, setDupCols] = useState([])

    const [cleanFlag, setCleanFlag] = useState(false);
    const [menubar, setMenubar] = useState(false);

    const classes = useStyles();
    const username = getUsernameFromToken();
    const [showSidebar, setShowSidebar] = useState(false);
    const [value, setValue] = React.useState(0);
    const handleLogout = () => {
        sessionStorage.removeItem("user");
        logout(appConfig.api);
    };
    const [anchorEl, setAnchorEl] = React.useState(null);


    const [openDrawer, setOpenDrawer] = useState(true);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleMenuBar = () => {
        setShowSidebar((prevState) => !prevState);
    };

    const handleMouseEnter = () => {
        setShowSidebar(true);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleMouseLeave = () => {
        setShowSidebar(false);
    };
    const handleHelpClick = () => {
        window.open('/htmldocs/html/index.html', '_blank');
    };
    const handleDrawerToggle = () => {
        setOpenDrawer(!openDrawer); // Toggle the drawer visibility
      };
    return (
        <SystemContext.Provider value={{
            numberOfRows, setNumberOfRows, numberOfColumns, setNumberOfColumns,
            numberOfDuplicateRows, setNumberOfDuplicateRows,
            numberOfDuplicateColumns, setNumberOfDuplicateColumns, statsData, setStatsData,
            numericalModeValue, setNumericalModeValue, categoricalModeValue, setCategoricalModeValue,
            outliersValue, setOutliersValue, fileObjects, setfileObjects, outlinerMethod, setOutlinerMethod,
            fileName, setFileName, cleanedData, setCleanedData, allColumns, setAllColumns, categoricalStatsData, setCategoricalStatsData,
            numericalColumns, setNumericalColumns, stringColumns, setStringColumns, rawOrCleanData, setRawOrCleanData,
            missingData, setMissingData, tempCleanData, setTempCleanData, taskToDo, setTaskToDo, numericalStatsCol, setNumericalStatsCol,
            numericalStatsData, setNumericalStatsData, categoricalStatsCol, setCategoricalStatsCol, taskToDoValue, setTaskToDoValue,
            targetVariableValue, setTargetVariableValue, scalingTechniqueValue, setScalingTechniqueValue, featureValue, setFeatureValue, strategForFeatureSelectionValue, setStrategForFeatureSelectionValue,
            numberOfModelsToTrain, setNumberOfModelsToTrain, keyMetricValue, setKeyMetricValue,
            timeStampCols, setTimeStampCols, numericalCleanedCols, setNumericalCleanedCols,
            categoricalCleanedCols, setCategoricalCleanedCols, allCleanedCols, setAllCleanedCols,
            cleaningInfo, setCleaningInfo, dupCols, setDupCols, cleanFlag, setCleanFlag, menubar, setMenubar, showSidebar, setShowSidebar,
            noOfRowsAfterCleaning, setNoOfRowsAfterCleaning, noOfColsAfterCleaning, setNoOfColsAfterCleaning, balancedCols, setBalancedCols, actualFileName, setActualFileName, images, setImages, table1Data, setTable1Data, table2Data, setTable2Data, table3Data, setTable3Data, modelName, setModelName,openDrawer
        }}>
            <CssBaseline>
                <AppBar position="static" className={classes.appbar}>
                    <Toolbar variant="dense">
                        {/* Menu Icon to toggle the drawer */}
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={handleDrawerToggle}
                        >
                            <MenuIcon />
                        </IconButton>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="Open drawer"
                            style={{ paddingLeft: "25px", marginLeft: "35px", width: "100px" }}
                        >
                            <Avatar aria-label="Logo" src={logo} className={classes.avatar} />
                        </IconButton>
                        <Typography className={classes.title} variant="h6" noWrap>
                            <label style={{ display: "flex", justifyContent: "center", fontSize: "1.5rem" }}>
                                Auto ML Tool
                            </label>
                        </Typography>
                        <Tooltip title="Click here for Help">
                            <h2 style={{ display: 'flex', marginRight: '1rem' }} onClick={handleHelpClick}>Help</h2>
                        </Tooltip>
                        <Box sx={{ flexGrow: 0 }}>
                            <Tooltip title={username}>
                                <IconButton
                                    onClick={handleClick}
                                    size="small"
                                    sx={{ ml: 2 }}
                                    aria-controls={open ? "account-menu" : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? "true" : undefined}
                                >
                                    <Avatar
                                        sx={{ width: 32, height: 32 }}
                                        style={{ backgroundColor: "silver" }}
                                    >
                                        {username
                                            ? username
                                                .split(" ")
                                                .map((word) => word.charAt(0).toUpperCase())
                                                .join("")
                                            : "UK"}
                                    </Avatar>
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <Menu
                            anchorEl={anchorEl}
                            id="account-menu"
                            open={open}
                            onClose={handleClose}
                            onClick={handleClose}
                            PaperProps={{
                                elevation: 0,
                                sx: {
                                    overflow: "visible",
                                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                    mt: 1.5,
                                    "& .MuiAvatar-root": {
                                        width: 32,
                                        height: 32,
                                        ml: -0.5,
                                        mr: 1,
                                    },
                                    "&::before": {
                                        content: '""',
                                        display: "block",
                                        position: "absolute",
                                        top: 0,
                                        right: 14,
                                        width: 10,
                                        height: 10,
                                        bgcolor: "background.paper",
                                        transform: "translateY(-50%) rotate(45deg)",
                                        zIndex: 0,
                                    },
                                },
                            }}
                            transformOrigin={{ horizontal: "right", vertical: "top" }}
                            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                        >
                            {/*<MenuItem onClick={handleClose}>*/}
                            {/*  <Avatar /> Profile*/}
                            {/*</MenuItem>*/}
                            {/*<MenuItem onClick={handleClose}>*/}
                            {/*  <Avatar /> My account*/}
                            {/*</MenuItem>*/}
                            {/*<Divider />*/}
                            {/*<MenuItem onClick={handleClose}>*/}
                            {/*  <ListItemIcon>*/}
                            {/*    <PersonAdd fontSize="small" />*/}
                            {/*  </ListItemIcon>*/}
                            {/*  Add another account*/}
                            {/*</MenuItem>*/}
                            <div style={{ display: 'inline-grid', padding: '5px' }}>
                                {/* <MenuItem onClick={handleClose}>
                                    <ListItemIcon>
                                        <Settings fontSize="small" />
                                    </ListItemIcon>
                                    Settings
                                </MenuItem> */}
                                <MenuItem onClick={handleLogout}>
                                    <ListItemIcon>
                                        <Logout fontSize="small" />
                                    </ListItemIcon>
                                    Logout
                                </MenuItem>

                            </div>
                        </Menu>
                    </Toolbar>
                </AppBar>
            </CssBaseline>
            {/* <MiniDrawer/> */}
            <Router>
                <VerticalTabs fetchAPI={fetchAPI} path="/" />
                {/* <UploadAndCleanData fetchAPI={fetchAPI} path="/upload"/>
                <DataVisualizationTabs_new fetchAPI={fetchAPI} path="/visualize"/>
                <FeatureProcessing fetchAPI={fetchAPI} path="/feature"/>
                <BuildMLModel fetchAPI={fetchAPI} path="/buildmodel"/> */}
            </Router>
        </SystemContext.Provider>
    );
}

export default AutoMLWorkflow;
